import * as React from 'react'
import $ from 'jquery'
import GridHeaderHelper from './GridHeaderHelper'
import ListgridButtons from './ListgridButtons'

interface MyProps {
    columns: {[s:string]:any},
    single_supplier_mode:boolean,
    skip_level2:boolean,
    columnkeys?: Array<string>

}
type MyState = {
    input_values: {[k:string]:string},
    select_values: {[k:string]:string}
}
class GridHeader extends React.PureComponent<MyProps,MyState> {
    constructor(props: MyProps) {
        super(props)

	this.reset_filters = this.reset_filters.bind(this)

	this.state = {
	    select_values:{},
	    input_values:{}
	}
    }
    filter_rows(){
	$('.grid-row > .row').removeClass('verberg')
	$('.grid-row').addClass('collapsed')

	let filters : {[k:string]: string } = {}
	document.querySelectorAll('.listgrid > .header input').forEach((e)=>{
	    let k = $(e).attr('name')
	    if(k !== undefined){
		let v = String( $(e).val()).toLowerCase()
		if(v){
		    filters[k] = v
		}
	    }
	});
	Object.entries(this.state.input_values).map(([k,v]:[string,string]) => {
	    filters[k] = v
	})
	Object.entries(this.state.select_values).map(([k,v]:[string,string]) => {
	    filters[k] = v
	})
	console.log(filters)
	document.querySelectorAll('.grid-row > .row').forEach((row) => {
	    Object.entries(filters).map(([name,val]:[string,string]) =>{
		// child: select column with given name by class
		let child = row.querySelector(`.${name}`)

		if(val !== '' && child !==null){
		    let text = ''
	    	    if(child.textContent !== null){
    			text = child.textContent.trim()
		    }
		    // filter via slug
		    let xdata = child.getAttribute('data-slug')
		    if(xdata !== null){
			console.log(` 1 - xdata : ${xdata} match possible filter ${name} = ${val}`)
			let verberg = true
			if(xdata === val){
			    verberg = false
			}else if(val === 'afgerond'){
			    if(text.toLowerCase().includes('afgerond')){
				verberg = false
			    }
			}else if(val === 'niet-afgerond'){
			    if(!text.toLowerCase().includes('afgerond')){
				verberg = false
			    }
			}
			else if(val === 'leeg'){
			    if(xdata === '' || xdata === 'kies'){
				verberg = false
			    }
			}
			if(verberg){
			    row.classList.add('verberg')
			}
		    }else{
			// filter via Text (for user visible label)
			console.log(` 2 -  [row-text ${text.length} ${text} ] filter by ${name} = ${val}`)
			if(val === 'leeg'){
			    if(text.length > 0){
				row.classList.add('verberg')
			    }
			}else if(val === 'niet-leeg'){
			    if(text.length === 0){
				row.classList.add('verberg')
			    }
			}else{
			    if(text.toLowerCase().includes(val.toLowerCase())){
				console.log('yep includes val')
			    }else{
				row.classList.add('verberg')
			    }
			}
		    }
		    console.log(` no child found for name ${name}`)
		}
	    })
	});
	return document.querySelectorAll('.row:not(.verberg)').length
    }
    change_select_filter(e:any,name:string){
	let tup: {[k:string]:string} = {}
	tup[name] = e.target.value
	this.setState(prevState => ({
	    select_values: {...prevState.select_values, ...tup}
	}),this.filter_rows)
	
    }
    change_filter_input(e:any,name:string){
	let tup: {[k:string]:string} = {}
	console.log(`change filter input ${name} `)
	tup[name] = e.target.value
	this.setState(prevState => ({
	    input_values: {...prevState.input_values, ...tup}
	}),this.filter_rows)

    }
    click_col_header(e:any){
	let gh = new GridHeaderHelper()
	gh.click_col_header(e)
    }
    reset_filters(){
	console.log('reset filters')
	this.setState({
	    input_values: {},
	})

	let gh = new GridHeaderHelper()
	gh.reset_filters()

	let keys = Object.keys(this.state.select_values)
	let tup: {[k:string]:string} = {}
	keys.map((k:string)=>{
	    tup[k] = ''
	})
	this.setState({
	    select_values: {...tup}

	})


    }
    render(){
	let columnkeys = this.props.columnkeys
	if(columnkeys === undefined){
	    columnkeys = Object.keys(this.props.columns)
	}

	return (
	       <div>
	       <ListgridButtons 
	          on_reset={this.reset_filters}
	       />
	    <div className={"quotation grid-header"}>
		<div className="pre-icon-h"></div>
		{columnkeys.map((name:string) => {
		    let coldef = this.props.columns[name]
		    let label = coldef.label
		    if(this.props.skip_level2 && name === 'level2'){ return null}
		    if(this.props.single_supplier_mode){
			if(name==='supplier'){return null}
		    }
		    let filter = (<div>UNDEFINED</div>)
		    if(coldef.type === 'select'){
			let val = this.state.select_values[name]

			filter = (
			    <select name={name} value={val} onChange={(e)=>this.change_select_filter(e,name)}>
			      {Object.entries(coldef.options).map(([ok,lab]:[string,any]) => (
				  <option key={ok} value={ok}>{lab}</option>
			      ))}
			    </select>
			)
		    }else if(coldef.type === 'txt' || coldef.type === 'int' || coldef.type === 'date'){
			filter = (
			    <input name={name} type={"text"} onChange={(e)=>this.change_filter_input(e,name)} />
			)
		    }
		    return (
		       	<div key={name} className={name + " hdr-label"} onClick={this.click_col_header}>
	    		    <div className="label"><div className="txt">{label}</div></div>
    			    {filter}
			</div>
		    )
		})}

	    </div>
	    </div>
	)
    }
}

export default GridHeader

